
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyAlert as SkyAlertElement, SkyAlertClosedEventDetail } from '@sky.ui/core/sky-alert';
 
 

 
 export const SkyAlert = createComponent({
   displayName: 'SkyAlert',
   react: React,
   tagName: 'sky-alert',
   elementClass: SkyAlertElement,
   events: {
     
     onAlertClosed: 'alert-closed' as EventName<CustomEvent<SkyAlertClosedEventDetail>>,
   }
  });
export type * from '@sky.ui/core/sky-alert';
